// B-77 — the pure half of the Cierres bell (`AvisosDeProceso.jsx`): how long ago, in words, and
// what a notification's outcome looks like. Nothing here fetches or knows a client.

const MINUTO = 60 * 1000;
const HORA = 60 * MINUTO;
const DIA = 24 * HORA;

// "hace un momento", "hace 5 min", "hace 2 h", "ayer", "hace 3 días", then the date. `ahora` is
// passed in so the tests hold still.
export function haceCuanto(fecha, ahora = new Date()) {
  const instante = new Date(fecha);
  if (Number.isNaN(instante.getTime())) return "";
  const pasado = ahora.getTime() - instante.getTime();
  if (pasado < MINUTO) return "hace un momento";
  if (pasado < HORA) return `hace ${Math.floor(pasado / MINUTO)} min`;
  if (pasado < DIA) return `hace ${Math.floor(pasado / HORA)} h`;
  if (pasado < 2 * DIA) return "ayer";
  if (pasado < 7 * DIA) return `hace ${Math.floor(pasado / DIA)} días`;
  return instante.toLocaleDateString("es-CO", { day: "2-digit", month: "2-digit", year: "numeric" });
}

// An outcome the backend does not name (a newer one) reads as neutral, never as success.
export const TONO_DE_AVISO = {
  DONE: "ok",
  WITH_PROBLEMS: "aviso",
  FAILED: "error",
};

export const tonoDeAviso = (outcome) => TONO_DE_AVISO[outcome] || "neutral";

// Where a notification takes you: that day of the panel.
export const rutaDeAviso = (aviso) =>
  aviso?.businessDate ? `/business/backoffice/panel-cierres?fecha=${encodeURIComponent(aviso.businessDate)}` : "/business/backoffice/panel-cierres";
